<template>
  <div class="phoneNav-index">
    <el-menu
      :default-active="'/' + activeIndex2"
      class="el-menu-vertical-demo"
      text-color="#666666"
    >
      <a
        v-for="(item, index) in menuList"
        :key="index"
        :href="item.index"
        :class="item.isSelected ? 'isSelected uuu' : ''"
      >
        <el-menu-item>{{ item.lable }}</el-menu-item>
      </a>
    </el-menu>
  </div>
</template>

<script lang="ts">
import { reactive, ref, toRefs, defineComponent, onBeforeMount } from "vue";
import { routerList } from "@/api/index";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "phoneNav",
  setup() {
    const menuList = ref();
    const route = useRoute();
    const activeIndex2 = ref("/");

    onBeforeMount(() => {
      activeIndex2.value = route.meta.index as string;
      routerList().then((res: any) => {
        if (res.code == 0) {
          menuList.value = res.data;
          menuList.value.forEach((item: any) => {
            item.isSelected = false;
            if (activeIndex2.value == item.index) {
              item.isSelected = true;
            }
          });
        }
      });
    });

    return {
      activeIndex2,
      menuList,
    };
  },
});
</script>
<style lang="less">
.phoneNav-index {
  z-index: 999;
  .el-menu {
    border: none;
    .el-menu-item {
      padding: 0 !important;
      text-align: left;
      display: block;
      line-height: 50px;
      padding-left: 0.4rem !important;
      height: 50px;
      position: relative;
      font-size: 16px;
      color: #666666;
    }
    .isSelected{
      .el-menu-item {
        color: #ffca28;
      }
    }
    // .el-menu-item.is-active {
    //   color: #ffca28;
    // }
  }
}
</style>
<style lang="less" scoped>
@import "@/assets/styles/common.less";
</style>